export const data = () => {
    return {
        file: null,
        voucher_type_id: null,
        disable_incorporation: 1,
        only_validation: 1,
        fixed_cost:1,
    }
}

export default {
    voucher_types: [],
    preloader: false,
    data: data()
}



// WEBPACK FOOTER //
// ./src/modules/incorporate_inventory_operations/state.js